import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Link } from "react-router-dom";

import Home from "./pages/home/index";


// Global stylesheets
import "./themes.css";
import "./forms.css";

const Booking = lazy(() => import("./pages/booking/index"));
const About = lazy(() => import("./pages/about/index"));
const Contact = lazy(() => import("./pages/contact/index"));
const MenuPage = lazy(() => import ("./pages/menu/index"));

function App() {
  return (
  <>

    <Suspense
      fallback={
        <main id='loadingScreen'>
          <h1>Thawing...</h1>
        </main>
      }
    >
      <Routes>
        <Route exact='true' path='/' element={<Home />} />
        <Route path='/booking' element={<Booking />} />
        <Route path='/about' element={<About />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/menuPage' element={<MenuPage />} />

        <Route
          path='/*'
          element={
            <main id='pageNotFound'>
              <h1>404: Page Not Found</h1>
              <Link to='/' className='link'>
                Home
              </Link>
            </main>
          }
        />
      </Routes>
    </Suspense>

    </>
  );
 
}

export default App;
